import request from "./request";

type typeProp = "products" | "shops";

const reviewService = {
  getAll: (id: number | string, type: typeProp = "products", params?: any) => {
    if (type === "products") {
      return request.get(`/rest/${type}/reviews/${id}`, { params });
    }
    return request.get(`/rest/${type}/${id}/reviews`, { params });
  },
  getSummary: (id: number, type: typeProp = "products", params?: any) =>
    request.get(`/rest/${type}/${id}/reviews-group-rating`, {
      params,
    }),
  canReview: (params?: any) => request.get(`/rest/added-review`, { params }),
  create: (id: number | string, type: typeProp = "products", body: any) =>
    request.post(`/rest/${type}/review/${id}`, body),
};

export default reviewService;
